module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"domain_authority":"Domain Authority","organicTraffic":"Organic traffic","organicKeywords":"Organic keywords"},"fr":{"domain_authority":"Domain Authority","organicTraffic":"Trafic organique","organicKeywords":"Mots-clés organiques"},"de":{"domain_authority":"Domänenautorität","organicTraffic":"Organischer Verkehr","organicKeywords":"Organische Schlüsselwörter"}}')
  delete Component.options._Ctor
}
